<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"></i>
        账户设置
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto ;">
      <div class="pending">
        <div class="pending_head">账户设置</div>
        <div class="pending_center">
          <div class="pending_center_div">
            <div class="pending_center_di_head">
              <div v-show="show1">
                <div v-if="headImg == '' ">
                  <i class="fas fa-user fa-5x" style="color:#CCC;margin-top:10px;"></i>
                </div>
                <img
                  width="100"
                  height="100"
                  v-else
                  style="border-radius: 50%;"
                  :src="serve+'/' +  headImg"
                  alt
                >
              </div>

              <img
                v-show="show2"
                :src="src3"
                style="border-radius: 50%;"
                width="100"
                height="100"
                alt
              >
            </div>
            <div class="pending_center_di_head1">
              <input
                type="file"
                @change="getImage($event)"
                accept="image/png, image/jpeg, image/jpg"
                style="width: 72px;opacity: 0;position: absolute;left: 120px;top: -4px;"
              >
              <span>上传头像</span>
            </div>
            <div class="pending_center_div_tab">
              <el-form label-width="100px" class="demo-ruleForm">
                <el-form-item label="用户名">
                  <el-input disabled v-model="user" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item label="部门">
                  <el-input disabled v-model="group"></el-input>
                </el-form-item>
                <el-form-item label="Email">
                  <el-input placeholder="请输入邮箱" v-model="email"></el-input>
                </el-form-item>

                <el-form-item label="旧密码">
                  <el-input type="password" v-model="old" placeholder="请输入旧密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码">
                  <el-input type="password" v-model="pass" placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码">
                  <el-input type="password" placeholder="请确认密码" v-model="checkPass"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="success" @click="submit()">提交</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
            serve: this.$store.state.serve,
      show1: true,
      show2: false,
      token: "",
      username: "",
      src3: "",
      reader: new FileReader(),
      email: "",
      headImg: "",
      user: "",
      group: "",
      old: "",
      pass: "",
      checkPass: "",
      msg: ""
    };
  },
  methods: {
    getImage(e) {
      this.show1 = false;
      this.show2 = true;

      var imgFile = e.target.files[0];
     
      this.reader.readAsDataURL(imgFile);
      var that = this;
      this.reader.onload = function() {
        that.src3 = that.reader.result;

        const formData = new FormData();
        formData.append("username", that.username);
        formData.append("token", that.token);
        formData.append("headImg", imgFile);
        that.axios
          .post(this.serve+"/admin/admin_headImg", formData)
          .then(res => {
          
            if (res.data.status == "success") {
              that.$message({
                type:'success',
                message:'上传头像成功'
              })
              that.geting();
            }else if(res.data.status == 'error'){
              that.$message.error('上传失败')
            }
          });
      };
    },
    geting() {
      
      // this.$store.state.left = "账户设置";
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/admin_user_edit", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          var json = res.data.data;
          if (res.data.status == "success") {
            that.user = json.username;
            that.email = json.email;
            that.group = json._group;
            that.headImg = json.headImg;
          }
        });
    },

    open6() {
      this.$message({
        showClose: true,
        message: "修改成功",
        type: "success"
      });
    },
    open8() {
      this.$message({
        showClose: true,
        message: this.msg,
        type: "error"
      });
    },

    submit() {
      if (this.email !== "") {
        var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (!reg.test(this.email)) {
          this.$message.error("请输入有效的邮箱");
          return;
        }
      }
      if (this.old !== "") {
        var pass = /^[A-Za-z0-9]{6,20}$/;
        if (!pass.test(this.old)) {
          this.$message.error("旧密码最小为6位数,最大为20位数");
          return;
        }
        // if(this.pass == ''){
        //   this.$message.error('新密码不能为空')
        // }
      }
      if (this.pass !== "") {
        var pass1 = /^[A-Za-z0-9]{6,20}$/;
        if (!pass1.test(this.pass)) {
          this.$message.error("新密码最小为六位数,最大为20位数");
          return;
        }
      }
      if (this.pass !== this.checkPass) {
        this.$message.error("两次输入密码不一致");
        return;
      }
      this.axios
        .get(this.serve+"/admin/admin_user_submit", {
          params: {
            username: this.username,
            token: this.token,
            email: this.email,
            old_pass: this.old,
            password: this.pass,
            new_pass: this.checkPass
          }
        })
        .then(res => {
         
          if (res.data.status == "success") {
            this.geting();
            this.open6();
            this.old = null;
            this.pass = null;
            this.checkPass = null;
          } else if (res.data.status == "error") {
            this.msg = res.data.msg;
            this.geting();
            this.open8();
          }
        });
    }
  },

  created() {
    this.$store.state.leftTitle = '账户设置'
    this.$store.state.topActiveId = 1;
    this.geting();
  }
};
</script>
<style lang="scss">
.list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
    .subTitle {
      width: 1056px;
      margin: 0 auto;
      font-size: 14px;
      position: relative;
      .rutun {
        width: 78px;
        height: 28px;
        background: #fff;
        border: 1px solid rgba(221, 221, 221, 1);
        text-align: center;
        margin-top: 9px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
      }
      .rutun:hover {
        color: #0099ff;
      }
    }
  }

  .pending {
    margin-top: 30px;
    .pending_head {
      width: 98.4%;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      line-height: 46px;
      padding-left: 16px;
    }
    .pending_center {
      background: #fff;
      .pending_center_div {
        width: 350px;
        // background: orange;
        margin: 0 auto;
        padding-top: 50px;
        .pending_center_di_head {
          width: 100px;
          margin: 0 auto;
          // padding-top: 30px;
          height: 100px;
          border: 4px solid #ccc;
          border-radius: 50%;
          text-align: center;
        }
        .pending_center_di_head1 {
          text-align: center;
          margin: 16px 16px;
          font-size: 14px;
          cursor: pointer;
          color: #3498db;
          position: relative;
        }
        .pending_center_div_tab {
          padding-bottom: 30px;
        }
      }
    }
  }
}
</style>